<template>
    <div class="l content_right">
        <div class="table_container">
            <el-table ref="tenantVersionTab" :data="tenantVersionList">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="tenantcode" label="租户ID" width="100px"></el-table-column>
                <el-table-column prop="tenantname" label="租户名称" width="200px"></el-table-column>
                <el-table-column prop="forceUpdateText" label="是否强制升级" width="120px"></el-table-column>
                <el-table-column prop="clientname" label="终端名称" ></el-table-column>
                <el-table-column prop="clienttypename" label="终端类型名称"></el-table-column>
                <el-table-column prop="versionname" label="终端版本名称"></el-table-column>
                <el-table-column prop="versionnum" label="版本号"></el-table-column>
                <el-table-column prop="url" label="url" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="ip" label="ip"></el-table-column>
                <el-table-column prop="certcode" label="证书"></el-table-column>
                <el-table-column prop="clientversiondescr" label="描述" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="sdk" label="sdk"></el-table-column>
            </el-table>
            <div class="paging">
                <el-pagination @current-change="handleCurrentPage" :current-page.sync="page" :page-size="rows" layout="total, prev, pager, next" :total="totalSize"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import {API_ROTT} from '../../config/index'

export default {
    data(){
        return {
            tenantVersionList:[],
            page: 1,
            rows: 15,
            totalSize: 0
        }
    },
    created(){
        this.init()
    },
    methods:{
        init(){
            this.loadList()
        },
        loadList(){
            let _this = this
            _this.$http.post('/platserv/tenant/tenantversion/list',{
                page:_this.page,
                rows:_this.rows
            }).then(res =>{
                _this.tenantVersionList = _this.formatData(res.data.resp_data.data)
                _this.totalSize = res.data.resp_data.resultCount
            }).catch(error =>{
                _this.errorMessage(error)
            })
        },
        handleCurrentPage(data) {
            this.currentPage = data
            this.loadList()
        },
        // 显示错误消息
        errorMessage(error) {
            let msg = (error.body && error.body.error_code) || error.statusText || error
            this.$message.error(msg)
        },
        formatData(data){
            var arr =["否","是"]
            return data.map(item =>{
                if(item.forceupdate && item.forceupdate > 0 && item.forceupdate <= arr.length){
                    item.forceUpdateText = arr[item.forceupdate - 1]
                }
                return item
            })
        }
    }
}
</script>




// WEBPACK FOOTER //
// Index.vue?73ed8f1e